var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageRender',{key:_vm.value.id,attrs:{"id":_vm.value.id,"sections":[_vm.value],"global-style":this.defaultGlobalStyles}})}
var staticRenderFns = []

export { render, staticRenderFns }